/**
 * Whether choosing a product asks for options first: a product of the old lists carries `product_extra_id`; a product of the
 * product index carries its `extra_groups` (and `has_extras`).
 */
export const productHasOptions = (product) => Boolean(
    product?.product_extra_id ||
    product?.has_extras === true ||
    (Array.isArray(product?.extra_groups) && product.extra_groups.length > 0)
);

/**
 * What the options dialog is opened with, from a product of the old lists or of the index: the same for the header search, the mobile
 * search and the browse all page, so the options are the same wherever the product was found.
 */
export const extrasDialogData = ({ product, qty, source, sectionID }) => ({
    product: {
        ...product,
        product_id: product?.product_id || product?.id,
        product_slug: product?.slug || product?.product_slug,
        name: product?.name || product?.product_name || '',
        product_extras_group_id: product?.extra_groups?.[0]?.group_id ?? product?.product_extras_group_id ?? null,
    },
    qty,
    source,
    sectionID,
});
